import React, { type ComponentType } from 'react';
import CommonFlag from '@atlassian/jira-flags/src/common/ui/components/common-flag';
import type { FlagComponentProps } from '@atlassian/jira-flags/src/services/types';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { messages } from './messages';

// @ts-expect-error - TS2322 - Type 'ComponentType<Diff<Record<any, any> & { children?: ReactNode; }, InjectIntlVoidProps>>' is not assignable to type 'ComponentType<FlagComponentProps>'.
export const AvatarFetchFailedFlag: ComponentType<FlagComponentProps> = injectIntl(
	// @ts-expect-error - Property 'formatMessage' does not exist on type 'IntlShapeV2 | IntlShape | undefined'.
	({ intl: { formatMessage }, ...props }) => (
		/* @ts-expect-error - Type '{ flagType: "error"; title: any; description: any; }' is not assignable to type 'IntrinsicAttributes & (CommonFlagProps & { packageName?: string | undefined; })'. */
		<CommonFlag
			{...props}
			flagType="error"
			title={formatMessage(messages.fetchFailedFlagTitle, {})}
			description={formatMessage(messages.fetchFailedFlagDescription, {})}
		/>
	),
);

// @ts-expect-error - TS2322 - Type 'ComponentType<Diff<Record<any, any> & { children?: ReactNode; }, InjectIntlVoidProps>>' is not assignable to type 'ComponentType<FlagComponentProps>'.
export const AvatarUploadFailedFlag: ComponentType<FlagComponentProps> = injectIntl(
	// @ts-expect-error - Property 'formatMessage' does not exist on type 'IntlShapeV2 | IntlShape | undefined'.
	({ intl: { formatMessage }, ...props }) => (
		/* @ts-expect-error - Type '{ flagType: "error"; title: any; description: any; }' is not assignable to type 'IntrinsicAttributes & (CommonFlagProps & { packageName?: string | undefined; })'. */
		<CommonFlag
			{...props}
			flagType="error"
			title={formatMessage(messages.uploadFailedFlagTitle, {})}
			description={formatMessage(messages.uploadFailedFlagDescription, {})}
		/>
	),
);
